import {
  GET_ASSET_LIST_DATA, DELETE_ASSET_LIST, DELETE_PORTFOLIO, SAVE_ASSET_LIST_DATA, SAVE_PORTFOLIO_ORDER_SETTINGS,
} from '../../constants/system/actions';

const getAssetListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_ASSET_LIST_DATA, payload, resolve, reject,
});

const deleteAssetList: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: DELETE_ASSET_LIST, payload, resolve, reject,
});

const deletePortfolio: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: DELETE_PORTFOLIO, payload, resolve, reject,
});

const saveAssetListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_ASSET_LIST_DATA, payload, resolve, reject,
});

const savePortfolioOrderSettings: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_PORTFOLIO_ORDER_SETTINGS, payload, resolve, reject,
});

export {
  getAssetListData,
  deleteAssetList,
  deletePortfolio,
  saveAssetListData,
  savePortfolioOrderSettings,
};
